import React from "react";

interface Props {
  pageName: string;
  backgroundImageUrl: string;
}

const PageHeader = ({ pageName, backgroundImageUrl }: Props) => {
  return (
    <div
      className="holiday-header"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
      }}
    >
      <div className="container">
        <h1 className="holiday-headline">{pageName}</h1>
        <p className="holiday-sub">
          Houston...our deals aren&apos;t live yet. Shop great products while
          you wait!
        </p>
      </div>
    </div>
  );
};

export default PageHeader;
